<template>
  <div class="w-100 bg-white">
    <Header></Header>
    <div class="px-10 py-5">
      <div class="row justify-content-center pt-5" id="payment-result">
        <div class="col-8 mb-5">
          <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey py-4 no-ws text-center">
            <template v-for="(menu,index) in stepper">
              <div class="d-inline-block align-middle">
                <div class="be-step-cart mr-2 d-inline-block align-middle" :class="{'active':menu.id <= data_parent.step}">
                  <span class="body-2-4" v-if="menu.id >= data_parent.step" :class="{'text-white': menu.id == data_parent.step }">{{ menu.id }}</span>
                  <div v-else style="line-height: 35px;">
                    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.79995 10.9L1.59995 6.7L0.199951 8.1L5.79995 13.7L17.8 1.7L16.4 0.300003L5.79995 10.9Z" fill="#fff"/>
                    </svg>
                  </div>
                </div>
                <p class="mb-0 d-inline-block align-middle" :class="menu.id != data_parent.step ?'body-2-1':'body-2-4 text-green'">{{ menu.name }}</p>
              </div>
              <div class="d-inline-block align-middle mx-4 px-3" v-if="(index+1) < stepper.length">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.74994 20.414L7.33594 19L14.3359 12L7.33594 5L8.74994 3.586L17.1639 12L8.74994 20.414Z" fill="#222"/>
                </svg>
              </div>
            </template>
          </div>
        </div>
        <div class="col-8">
          <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey p-4 no-ws">
            <div class="text-center" v-if="data_parent.is_load">
              <loader></loader>
            </div>
            <template v-else>
              <ErrorMessage v-if="data_parent.error != ''" :message="data_parent.error"></ErrorMessage>
              <template v-else>
                <!-- COMPLETE -->
                <template v-if="data_parent.trx.status == 'COMPLETE' || data_parent.trx.status == 'CANCELLED'">
                  
                  <div class="mb-5 text-center" v-if="data_parent.trx.status == 'COMPLETE'">
                    <img src="../../assets/img/icon/green-checked-2.png" class="mb-4 img-check">
                    <p class="heading-5-2 text-green mb-0 text-uppercase">{{ $t('ticket.your-booking-complete') }}</p>
                    <p class="mb-0 body-2-2-1 mb-3">{{ $t('ticket.thanks-for-order') }}</p>
                    <p class="mb-0 text-24 font-lato text-ticket">{{ $formatCurrency(data_parent.total.with_surcharge) }}</p>
                  </div>
                  
                  <div class="mb-5 text-center" v-else>
                    <img src="../../assets/img/icon/uncheck.png" class="mb-4 img-check">
                    <p class="heading-5-2 text-danger mb-0 text-uppercase">{{ $t('ticket.your-booking-cancelled') }}</p>
                  </div>

                  <!-- PREVIEW -->
                  <div class="w-100 border-form mb-4 radius-6" v-if="data_parent.trx.status == 'COMPLETE'">
                    <div class="row">
                      <div class="col-2 align-self-center">
                        <img :src="getMerchant.image_url" width="100%" />
                      </div>
                      <div class="col-8 align-self-center">
                        <div class="border-l-secondary-t pl-3">
                          <p class="sub-heading-1-2 text-black mb-1">{{ data_parent.total.qty }} {{ $pluralWord(data_parent.total.qty,'ticket') }} have been booked</p>
                          <div class="w-100 no-ws mb-1">
                            <p class="mb-0 body-3-3-1 d-inline-block align-middle">{{ $t('ticket.visit-date') }} : </p>
                            <p class="body-3-3-2 text-black mb-0 d-inline-block align-middle ml-1">{{ $formatDate(data_parent.trx.visit_date) }}</p>
                          </div>
                          <div class="w-100 no-ws">
                            <p class="mb-0 body-3-3-1 d-inline-block align-middle">Order ID : </p>
                            <p class="body-3-3-2 text-black mb-0 d-inline-block align-middle ml-1">{{ data_parent.trx.ticket_code }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-2 align-self-center">
                        <img :src="data_parent.trx.url" width="100%" />
                      </div>
                    </div>
                  </div>
                  
                  <div class="row mb-4">
                    <!-- TICKET -->
                    <div class="col-md-8 col-12 mb-4 mb-md-0">
                      <div class="w-100 border-form radius-6 h-100 position-relative" style="padding-bottom: 56.667px;">
                        <div class="p-3 bg-green-light-2 border-b-form radius-t-6 ">
                          <div class="row no-gutters">
                            <div class="col-8">
                              <p class="mb-0 body-1-4">{{ $t('ticket.ticket') }}</p>
                            </div>
                            <div class="col-4 text-right">
                              <p class="mb-0 body-1-4">{{ $t('ticket.price') }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="row no-gutters" v-for="(item,index) in data_parent.trx.ticket_details" :class="{'mb-3': index+1 < data_parent.trx.ticket_details.length }">
                            <div class="col-1 align-self-center">
                              <p class="body-1-2 font-lato mb-0 text-ticket">{{ item.qty }}X</p>
                            </div>
                            <div class="col-7 align-self-center">
                              <div class="pl-mobile">
                                <p class="mb-0 body-2-1">{{ item.product_name }}</p>
                                <p class="mb-0 body-3-3" v-if="item.variant_name != ''">{{ item.variant_name }}</p>
                              </div>
                            </div>
                            <div class="col-4 align-self-center text-right">
                              <p class="mb-0 body-2-1">{{ $formatCurrency(item.best_price.final_price*item.qty) }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3 border-t-d-secondary-t position-absolute w-100" style="bottom: 0;">
                          <div class="row no-gutters">
                            <div class="col-8">
                              <p class="mb-0 body-1-4">{{ $t('ticket.total') }}</p>
                            </div>
                            <div class="col-4">
                              <p class="mb-0 body-1-4 text-right">{{ $formatCurrency(data_parent.total.price) }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- GUEST DETAIL -->
                    <div class="col-md-4 col-12">
                      <div class="w-100 border-form radius-6 h-100">
                        <div class="p-3 bg-green-light-2 border-b-form radius-t-6 ">
                          <div class="row no-gutters">
                            <div class="col-12">
                              <p class="mb-0 body-1-4">{{ $t('ticket.guest-detail') }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="row no-gutters">
                            <div class="col-12 mb-3">
                              <div class="w-100 pr-3">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.name') }}</p>
                                <p class="mb-0 body-2-1">{{ data_parent.trx.customer_details.full_name }}</p>
                              </div>
                            </div>
                            <div class="col-12 mb-3" v-if="$isNotEmpty(data_parent.trx.customer_details.country)">
                              <div class="w-100">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.country') }}</p>
                                <p class="mb-0 body-2-1">{{ data_parent.trx.customer_details.country }}</p>
                              </div>
                            </div>
                            <div class="col-12 mb-3">
                              <div class="w-100">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.email') }}</p>
                                <p class="mb-0 body-2-1">{{ data_parent.trx.customer_details.email }}</p>
                              </div>
                            </div>
                            <div class="col-12" v-if="$isNotEmpty(data_parent.trx.customer_details.phone_number)">
                              <div class="w-100">
                                <p class="mb-0 body-3-3-1">{{ $t('ticket.phone-number') }}</p>
                                <p class="mb-0 body-2-1">{{ data_parent.trx.customer_details.phone_number }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- PAYMENT -->
                  <div class="row">
                    <div class="col-12" v-if="Number(data_parent.trx.total_payment) > 0">
                      <div class="w-100 border-form radius-6 h-100">
                        <div class="p-3 bg-green-light-2 border-b-form radius-t-6 ">
                          <div class="row no-gutters">
                            <div class="col-12">
                              <p class="mb-0 body-1-4">{{ $t('ticket.payment-detail') }}</p>
                            </div>
                          </div>
                        </div>
                        <div class="p-3">
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-method') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ data_parent.trx.payment_channel.name }}</p>
                            </div>
                          </div>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-time') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ $formatDateTime(data_parent.trx.payment_details.pay_at) }}</p>
                            </div>
                          </div>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-surcharge') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ $formatCurrency(data_parent.trx.payment_surcharge) }}</p>
                            </div>
                          </div>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.total-paid') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1">{{ $formatCurrency(data_parent.total.with_surcharge) }}</p>
                            </div>
                          </div>
                          <div class="w-100 my-3 border-t-d-secondary-t"></div>
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ $t('ticket.payment-status') }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-4 text-success text-uppercase" v-if="data_parent.trx.status == 'COMPLETE'">{{ $t('ticket.success') }}</p>
                              <p class="mb-0 body-2-4 text-danger text-uppercase" v-if="data_parent.trx.status == 'CANCELLED'">{{ $t('ticket.cancelled') }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Swipe to Claim -->
                    <div class="col-6 offset-3 mt-5 pt-4 border-2-top-dashed" v-if="getMerchant.redeem_type == 'MANUAL' && data_parent.trx.status == 'COMPLETE'">
                      <div class="w-100 p-3 bg-green-light-2 radius-6" v-if="data_parent.redeem.claimed">
                        <p class="mb-0 body-1-4 text-center">
                          This ticket has been claimed
                        </p>
                      </div>
                      <template v-else>
                        <p class="body-2-4 text-danger mb-3 text-center" v-if="data_parent.redeem.error != ''">{{ data_parent.redeem.error }}</p>
                        <template v-if="data_parent.trx.flexible_service_date_max_late > 0">
                          <p class="body-2-2 mb-3 text-center" :class="{'text-danger':data_parent.is_expired}">You can redeem the ticket from <b>{{ $formatDate(data_parent.trx.visit_date,'YYYY-MM-DD') }}</b> until <b>{{ $formatDate(data_parent.trx.visit_date_max_late,'YYYY-MM-DD') }}</b></p>
                        </template>
                        <template v-else>
                          <p class="body-2-4 text-danger mb-3 text-center" v-if="!data_parent.is_valid_to_redeem">Tickets can only be redeemed on the visit date</p>
                        </template>
                        <slide-unlock
                          ref="vueslideunlock"
                          :auto-width="true"
                          :circle="true"
                          :disabled="!data_parent.is_valid_to_redeem"
                          :noanimate="false"
                          :width="400"
                          :height="60"
                          text="Slide to redeem"
                          :success-text="data_parent.redeem.claimed ? 'Claimed' : 'Please Wait..'"
                          @completed="redeemTicket()"
                          />
                      </template>
                    </div>
                  </div>
                  
                </template>
                <template v-if="data_parent.trx.status == 'WAITING_PAYMENT_CONFIRMATION'">
                  <template v-if="data_parent.trx.payment_details.bank_name == 'BPD_BALI'">
                    <BPDVirtualAccountForm :tx_date="data_parent.trx.transaction_date" :payment_detail="data_parent.trx.payment_details" :data="data_parent.trx.payment_details.payment_gateway_response" :channel="data_parent.trx.payment_details.payment_channel" v-if="data_parent.trx.payment_details.payment_method == 'VIRTUAL_ACCOUNT'"  />
                    <BPDQrisForm :data="data_parent.trx.payment_details.payment_gateway_response" v-else />
                  </template>
                  <template v-else>
                    <DokuForm v-if="data_parent.trx.payment_details.payment_method == 'CREDIT_CARD' && data_parent.trx.payment_details.bank_name == 'DOKU'"></DokuForm>
                    <VirtualAccount v-else-if="data_parent.trx.payment_details.payment_method == 'VIRTUAL_ACCOUNT'" :data="data_parent.trx" module_page="TICKET" :customer_detail="data_parent.trx.customer_details"></VirtualAccount>
                    <Qris 
                      v-if="data_parent.trx.payment_details.payment_method == 'QRIS'"
                      :data="data_parent.trx"
                      module_page="TICKET"
                      :customer_detail="data_parent.trx.customer_detail" />
                  </template>
                  <div class="w-100 text-center mt-5">
                    <p class="body-2-4 mb-3">{{$t("hotel.waiting.already-made-a-payment")}}</p>
                    <state-button variant="primary-ticket" size="lg" :click="checkStatus">{{$t("hotel.waiting.check-payment-status")}}</state-button>
                    <p class="body-2-4 text-danger mb-0 mt-2" v-if="data_parent.payment_still_not_complete">{{$t("hotel.waiting.payment-still-not-processed")}}</p>
                  </div>
                </template>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import VirtualAccount from '@/components/general/payment/VirtualAccount'
  import BPDVirtualAccountForm from '@/components/ticket/VirtualAccountForm';
  import Qris from '@/components/general/payment/Qris';
  import BPDQrisForm from '@/components/ticket/QrisForm';
  import DokuForm from '@/components/ticket/DokuForm';
  import { mapGetters } from 'vuex';
  import Footer from '../../components/ticket/Footer';
  import Header from '../../components/ticket/Header';
  import SlideUnlock from "vue2-slide-unlock"

  export default {
    props: ['data_parent','check_status','redeem_ticket'],
    components:{
      VirtualAccount,
      Qris,
      Footer,
      Header,
      SlideUnlock,
      DokuForm,
      BPDVirtualAccountForm,
      BPDQrisForm
    },
    data(){
      return{
        stepper:[
          {id: 1, name: 'Select Ticket '},
          {id: 2, name: 'Fill in data'},
          {id: 3, name: 'Payment'}
        ]
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      tx_order_id(){
        return this.$route.params.tx_order_id
      }
    },
    methods:{
      checkStatus(){
        return new Promise((success,fail)=>{
          this.check_status().finally(()=>success())
        })
      },
      redeemTicket(){
        this.$emit('toggleRedeemWarning')
      },
      resetSlider(){
        this.$refs.vueslideunlock.reset()
      }
    }
  }
</script>
<style>
  .be-step-cart{
    width: 35px;
    height: 35px;
    background-color: #ececec;
    border-radius: 50%;
    border: 1px solid #9f9f9f;
    text-align: center;
  }
  .be-step-cart > span{
    line-height: 35px !important;
  }
  .be-step-cart.active{
    background-color: var(--merchant-primary-color);
    border: 1px solid var(--merchant-primary-color);
  }
  .be-step-cart.active-mobile{
    background-color: #fff;
    border: 1px solid #fff;
  }
  .svg-primary{
    fill: var(--merchant-primary-color)
  }
  .img-check{
    height: 100px;    
  }
  @media screen and (max-width: 767px){
    .be-step-cart{
      background-color: var(--merchant-primary-color);
      border: 1px solid #fff;
      width: 25px;
      height: 25px;
    }
    .be-step-cart > span{
      line-height: 25px !important;
    }
  }
  @media screen and (max-width: 400px){
    .sub-heading-1-2{
      font-size: 14px;
    }
    .pl-mobile{
      padding-left: 10px;
    }
    .img-check{
      height: 60px;    
    }
  }
</style>


// WEBPACK FOOTER //
// src/pages/ticket/TicketPaymentFormDesktop.vue